import { memo, useCallback, useMemo, useState } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { ReactComponent as LogoIcon } from './new_apl_icon_white.svg';
import styles from './index.module.scss';
import { Search } from './Search';
import { ACCOUNT_REG_EXP_COMMON } from '../../constants';

const navList = [
  { name: 'Transactions', path: '/transactions' },
  { name: 'Blocks', path: '/blocks' },
  { name: 'Accounts', path: '/accounts' },
  { name: 'NXT Airdrop', path: '/nxt-airdrop' },
  { name: 'Peers', path: '/peers' },
];

const SiteHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const handleMobileOpen = () => {
    setIsOpen((state) => !state);
  };

  const renderAccount = useCallback(() => {
    const isAnyEnteredAccount = ACCOUNT_REG_EXP_COMMON.test(location.pathname);
    const handler = () => {
      if (!isAnyEnteredAccount) {
        history.push({
          pathname: location.pathname,
          search: '?account=1',
        });
      }
    };

    return (
      <div>
        <span
          className={classNames(styles.navLink, { [styles.navLinkActive]: isAnyEnteredAccount })}
          onClick={handler}
        >
          Accounts
        </span>
      </div>
    );
  }, [history, location.pathname]);

  const list = useMemo(
    () =>
      navList.map(({ name, path }) =>
        path === '/accounts' ? (
          <div className={styles.navMenuItem} key={path}>
            {renderAccount()}
          </div>
        ) : (
          <NavLink
            className={styles.navMenuItem}
            key={path}
            to={path}
            activeClassName={styles.navLinkActive}
          >
            <span className={styles.navLink}>{name}</span>
          </NavLink>
        ),
      ),
    [renderAccount],
  );

  return (
    <header>
      <nav className={styles.nav}>
        <div className={styles.navWrapper}>
          <NavLink className={styles.navLogo} to='/'>
            <LogoIcon height={40} width={49} />
          </NavLink>
          <div className={classNames(styles.navMenu)}>{list}</div>
          <div className={styles.navSearchBlock}>
            <Search className={styles.navSearch} />
            <button
              className={styles.navButtonMobile}
              onClick={handleMobileOpen}
              aria-label='Open or close mobile menu'
            >
              <span className={styles.navButtonMobileIcon} />
            </button>
          </div>
        </div>
        <div className={classNames(styles.navMobile, { [styles.navMobileOpen]: isOpen })}>
          {list}
        </div>
      </nav>
    </header>
  );
};

export default memo(SiteHeader);
